import * as React from "react";

export interface CurrentSnapshotCitation {
  outcomeResultId: string;
  snapshotOutcomeId: string;
  startOffset?: number;
  endOffset?: number;
}

export interface CurrentSnapshotCitationContextValue {
  currentSnapshotCitation: CurrentSnapshotCitation | null;
  setCurrentSnapshotCitation: (citation: CurrentSnapshotCitation | null) => void;
}

const noop = () => {};

const defaultValue: CurrentSnapshotCitationContextValue = {
  currentSnapshotCitation: null,
  setCurrentSnapshotCitation: noop,
};

export const CurrentSnapshotCitationContext = React.createContext<CurrentSnapshotCitationContextValue>(defaultValue);

export const useCurrentSnapshotCitation = (): CurrentSnapshotCitationContextValue =>
  React.useContext(CurrentSnapshotCitationContext);
